import { Component, inject, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ContactInfo, ItemMenu } from '../../../types/menu';
import { ContactsInfo, Menu, MenuEn } from '@shared/data/data';
import { ValueGlobalService } from '@services/global/value.global.service';

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [RouterLink, RouterLinkActive],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
    readonly #valueGlobalService = inject(ValueGlobalService);
    readonly localeDefaultService = this.#valueGlobalService.locale;
    menus: ItemMenu[];
    contactsInfo: ContactInfo[] = ContactsInfo;

    ngOnInit(): void {
        //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
        //Add 'implements OnInit' to the class.
        if (this.localeDefaultService() === 'vi') {
            this.menus = Menu;
        } else {
            this.menus = MenuEn;
        }
    }
}
